import { useEffect, useId } from 'react';

const BODY_SCROLLING_CLASS_NAME = 'prevent-scrolling';

const usePreventBodyScrolling = (shouldPrevent: boolean) => {
  const id = useId();
  useEffect(() => {
    if (shouldPrevent) {
      document.body.classList.add(`${BODY_SCROLLING_CLASS_NAME}${id}`);
      return () =>
        document.body.classList.remove(`${BODY_SCROLLING_CLASS_NAME}${id}`);
    }
    return undefined;
  }, [shouldPrevent, id]);
};

export default usePreventBodyScrolling;
